/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_AdvertisementInputs */

const en_common_advertisement = /** @type {(inputs: Common_AdvertisementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertisement`)
};

/**
* | output |
* | --- |
* | "Advertisement" |
*
* @param {Common_AdvertisementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_advertisement = /** @type {((inputs?: Common_AdvertisementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_AdvertisementInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_advertisement(inputs)
});
export { common_advertisement as "common.advertisement" }